/**
 * Поиск модели CRM по фото папки (`GET /api/dresses/{id}/crm/match`, задача №374): чистые функции
 * блока `CrmMatch` — режим города, подпись наличия, что слать в привязку.
 * Спека `docs/superpowers/specs/2026-10-22-dress-crm-match-design.md`.
 */

export type MatchCity = { id: number; name: string };

export type MatchCard = {
  model_id: number;
  name: string | null;
  article: string | null;
  score: number;
  best: number;
  matched: number;
  photo_id: number;
  photo_url: string | null;
  photos: string[];
  cities: { id: number; name: string; serials: number }[];
  serial_here: string | null;
  /** серия экземпляра для привязки: в городе → в наличии → любой неудалённый */
  bind_series: string | null;
  bound: boolean;
};

export type MatchResult = {
  city: MatchCity | null;
  dress_city: MatchCity | null;
  photos_total: number;
  photos_with_vector: number;
  cards: MatchCard[];
  error: string | null;
};

/** `null` — город фото (решает сервер), `"all"` — все салоны, иначе id города. */
export type CityMode = string | null;

export function matchQuery(city: CityMode): string {
  return city === null ? "" : `?city=${encodeURIComponent(city)}`;
}

/** Переключатель: город фото и «все салоны»; города фото нет — только «все салоны». */
export function cityOptions(
  res: Pick<MatchResult, "dress_city">,
): { value: string; label: string }[] {
  const all = { value: "all", label: "все салоны" };
  return res.dress_city
    ? [{ value: String(res.dress_city.id), label: res.dress_city.name }, all]
    : [all];
}

/** Что выбрано в переключателе по ответу сервера. */
export function cityValue(res: Pick<MatchResult, "city">): string {
  return res.city ? String(res.city.id) : "all";
}

export function percent(score: number): number {
  return Math.round(score * 100);
}

/** «Санкт-Петербург 1 · Новосибирск 2»; нет наличия — «нет в наличии». */
export function citiesLine(cities: MatchCard["cities"]): string {
  return cities.length
    ? cities.map((c) => `${c.name} ${c.serials}`).join(" · ")
    : "нет в наличии";
}

/** Привязка — всегда СЕРИЕЙ экземпляра (её даёт сервер): артикул `crmdress.bind` мог бы принять за чужую серию.
 * Серии нет — привязать нечем, `null`. */
export function bindArgs(
  card: Pick<MatchCard, "bind_series" | "model_id">,
): { series: string; modelId: number } | null {
  return card.bind_series ? { series: card.bind_series, modelId: card.model_id } : null;
}

/** Остальные фото модели для полоски — без того, что уже стоит крупно. */
export function otherPhotos(
  card: Pick<MatchCard, "photos" | "photo_url">,
  max = 5,
): string[] {
  return card.photos.filter((u) => u !== card.photo_url).slice(0, max);
}
